import React from "react";
import "./CallMeDialog.css";
import { useNavigate } from "react-router";
const CallMeDialog = ({ open, onClose }) => 
{
  let nav=useNavigate();
  function storeData(event)
  {
    event.preventDefault();  
    nav("/kit1");
  }
  return (
    <div className="dialog-backdrop">
      <div className="dialog-container">
        <h4 className="dialog-title">We Will Contact You / हम आपसे संपर्क करेंगे  </h4>       
          <div className="dialog-body">
            <form onSubmit={storeData}>
              <input type="text" placeholder="Name / नाम " style={{color:'black'}} className="dialog-input mb-1" required />
              <input type="tel"  placeholder="Mobile / मोबाइल " style={{color:'black'}} className="dialog-input mb-1" required />
              <textarea placeholder="Describe your problem / अपनी समस्या बतायें " style={{color:'black'}} className="dialog-textarea" required>
              </textarea>
              <button className="dialog-button">Call Me / मुझसे संपर्क करें</button>
            </form>
        </div>
      </div>
    </div>
  );
};
export default CallMeDialog;
